module.exports = __webpack_public_path__ + "static/w_neun-d5545208a1bec4db9c76963a70795cd3.jpg";